import { Equipment, Extractor, RotationType, sitesEacm } from "@/models/equipment.model";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import store from "..";
import _ from 'lodash';

import {
  RESET_EQUIPMENTS,
  UPDATE_CUSTOM_EQUIPMENT_LABEL,
  UPDATE_EACM_EQUIPMENT,
  UPDATE_OPTIONAL_EACM_EQUIPMENT, /*Evolution Majeure composition de EACM*/
  UPDATE_EAR_EQUIPMENT,
  UPDATE_IS_EAR_MANDATORY,
  UPDATE_MANDATORY_EXTRACTOR,
  UPDATE_MANDATORY_EXTRACTOR_AND_STATUS,
  UPDATE_MANDATORY_EXTRACTOR_COUNT,
  UPDATE_OPTIONAL_EXTRACTOR,
  UPDATE_OPTIONAL_EXTRACTOR_COUNT,
  UPDATE_SECURITY_EXTRACTOR_ENABLED,
  UPDATE_OPTIONAL_EACM_SITES, /*Evolution Majeure composition de EACM*/
} from "../operators";
import { ElementaryZone } from "@/models/site.model";

/**
 * This module contains the generic equipments in the site.
 * The equipments linked to a specific zone (decontamination airlocks equipments) are stored in site module.
 */
@Module
export default class EquipmentsStore extends VuexModule {
  // site variables
  public mandatoryExtractor!: Extractor;
  public optionalExtractor!: Extractor;
  public eacmEquipment!: Equipment;
  public optionalEacmEquipment!: Equipment; /*Evolution Majeure composition de EACM*/
  public earEquipment!: Equipment;
  public isSecurityExtractorRequired = true;
  public mandatoryExtractorCount = 1;
  public optionalExtractorCount = 1;
  public isEarMandatory = true;
  public customEquipmentLabel!: string;
  public mandatoryEacmSites: ElementaryZone[] =[];/*Evolution Majeure composition de EACM*/
  public optionalEacmsites: ElementaryZone[] =[];/*Evolution Majeure composition de EACM*/

  @Mutation
  public [UPDATE_MANDATORY_EXTRACTOR](mandatoryExtractor: Extractor): void {
    this.mandatoryExtractor = mandatoryExtractor;
  }

  @Mutation
  public [UPDATE_OPTIONAL_EXTRACTOR](optionalExtractor: Extractor): void {
    this.optionalExtractor = optionalExtractor;
  }

  @Mutation
  public [UPDATE_EACM_EQUIPMENT](eacmEquipment: Equipment): void {
    this.eacmEquipment = eacmEquipment;
  }

  /*Evolution Majeure composition de EACM*/
  @Mutation
  public [UPDATE_OPTIONAL_EACM_EQUIPMENT](eacmEquipment: Equipment): void {
    this.optionalEacmEquipment = eacmEquipment;
  }

  @Mutation
  public [UPDATE_EAR_EQUIPMENT](earEquipment: Equipment): void {
    this.earEquipment = earEquipment;
  }

  @Mutation
  public [UPDATE_SECURITY_EXTRACTOR_ENABLED](isSecurityExtractorRequired: boolean): void {
    this.isSecurityExtractorRequired = isSecurityExtractorRequired;
  }

  @Mutation
  public [UPDATE_MANDATORY_EXTRACTOR_COUNT](mandatoryCount: number): void {
    this.mandatoryExtractorCount = mandatoryCount;
  }

  @Mutation
  public [UPDATE_OPTIONAL_EXTRACTOR_COUNT](optionalCount: number): void {
    this.optionalExtractorCount = optionalCount;
  }

  /*Evolution Majeure composition de EACM*/
  @Mutation
  public [UPDATE_OPTIONAL_EACM_SITES](optionalSitesAdd: ElementaryZone[]): void {
   this.optionalEacmsites= optionalSitesAdd ;
  }

  @Mutation
  public [UPDATE_IS_EAR_MANDATORY](newEarStatus: boolean): void {
    this.isEarMandatory = newEarStatus;
  }

  @Mutation
  public [UPDATE_CUSTOM_EQUIPMENT_LABEL](value: string): void {
    this.customEquipmentLabel = value;
  }

  /**
   * Save a new mandatory extractor in store. Since ear status (optional or mandatry) is defined by this
   * mandatory extractor's rotation type we also update it in the same action.
   * This method can also be used to delete the current extractor.
   * @param newExtractor if newExtractor is null we delete the current extractor.
   */
  @Action
  public [UPDATE_MANDATORY_EXTRACTOR_AND_STATUS](newExtractor: Extractor): void {
    store.commit(UPDATE_MANDATORY_EXTRACTOR, newExtractor);

    if (newExtractor) {
      store.commit(UPDATE_IS_EAR_MANDATORY, newExtractor.rotation_type === RotationType.set);
    } else {
      //If newExtractor is null, it means we're deleting the current extractor in store. So we have to reset is ear mandatory to true
      store.commit(UPDATE_IS_EAR_MANDATORY, true);
    }
  }

  @Action
  public [RESET_EQUIPMENTS](): void {
    store.commit(UPDATE_MANDATORY_EXTRACTOR, null);
    store.commit(UPDATE_OPTIONAL_EXTRACTOR, null);
    store.commit(UPDATE_EACM_EQUIPMENT, null);
    store.commit(UPDATE_OPTIONAL_EACM_EQUIPMENT, null); /*Evolution Majeure composition de EACM*/
    store.commit(UPDATE_EAR_EQUIPMENT, null);
    store.commit(UPDATE_SECURITY_EXTRACTOR_ENABLED, true);
    store.commit(UPDATE_MANDATORY_EXTRACTOR_COUNT, 1);
    store.commit(UPDATE_OPTIONAL_EXTRACTOR_COUNT, 1);
    store.commit(UPDATE_IS_EAR_MANDATORY, true);
    store.commit(UPDATE_CUSTOM_EQUIPMENT_LABEL, null);
    store.commit(UPDATE_OPTIONAL_EACM_SITES,null); /*Evolution Majeure composition de EACM*/

  }
}
